import React, { useState } from 'react';
import { StyledContainer } from '../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import CreateClinicHeader from './components/CreateClinicHeader';
import useClinicForm from './hooks/useClinicForm';
import CreateClinicBody from './components/CreateClinicBody';
import CreateClinicFooter from './components/CreateClinicFooter';

const CreateClinic = () => {
  const [selectedClinicToClone, setSelectedClinicToClone] = useState<string | null>(null);
  const form = useClinicForm({ selectedClinicToClone, isCreateMode: true });

  const handleClinicToCloneChange = (clinicId: string | null) => {
    setSelectedClinicToClone(clinicId);
  };

  return (
    <StyledContainer>
      <CreateClinicHeader />
      <CreateClinicBody
        form={form}
        selectedClinicToClone={selectedClinicToClone}
        onClinicToCloneChange={handleClinicToCloneChange}
        isCreateMode={true}
      />
      <CreateClinicFooter
        form={form}
        selectedClinicToClone={selectedClinicToClone}
      />
    </StyledContainer>
  );
};

export default CreateClinic;
